import { transformComponent } from '../../__builtins__/shared'
import { connect, mapProps, mapReadPretty } from '@formily/vue'
import { InputPreviewText } from '../PreviewText'
import { Input as RichInput } from '@didi/rich-ui'
import './style.scss'

const TransformElInput = transformComponent(RichInput, {
  change: 'input'
})

const Input = connect(
  TransformElInput,
  mapProps({ readOnly: 'readonly' }),
  mapReadPretty(InputPreviewText)
)

export default Input
